import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { addPortalSuccess, addPortalFailed } from '../actions';
import { PortalActionTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* savePortal({ data }) {
  const { formData } = data;

  const url = `${API_BASE_URL}/organisation/portal`;

  const response = yield request({
    method: 'put',
    data: formData,
    url,
  });
  if (response.success) {
    yield put(addPortalSuccess(response.raw));
    Notify('Portal Settings Saved Successfully!', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
  } else {
    yield put(addPortalFailed(response.message));
    networkErrorHandler(response?.statusCode, 'Portal Title and Welcome Message are required');
  }
}

export function* savePortalSettings() {
  yield takeLatest(PortalActionTypes.ADD_PORTAL, savePortal);
}
